// Angular + External  modules
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule, RouterOutlet } from "@angular/router";
// BFX
import { PageNotFoundComponent } from "./not-found.component";
import { PageNotAuthorizedComponent } from "./not-authorized.component";
import { BrandingComponentsModule } from "shared/branding/branding-components.module";

@NgModule({
  declarations: [PageNotFoundComponent, PageNotAuthorizedComponent],
  exports: [PageNotFoundComponent, PageNotAuthorizedComponent],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    FlexLayoutModule,
    BrandingComponentsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class PageErrorModule {}
